/**
 * © 2022 WavePlay <dev@waveplay.com>
 */
import type { PageModule, PageRoute } from '../_internal/types'

// This is just a stub for what gets automatically generated by `pilot build`
export const pageRoutes: PageRoute[] = []
export async function importPage(routePath: string): Promise<PageModule> {
	throw new Error(
		`[PilotJS] Imported "${routePath}" using stubbed importPage(). Please file an issue on GitHub if you see this.`
	)
}
